import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ChatDisclaimerState {
  isDismissed: boolean;
  dismiss: () => void;
}

export const useChatDisclaimerStore = create<ChatDisclaimerState>()(
  persist(
    (set) => ({
      isDismissed: false,
      dismiss: () => set({ isDismissed: true }),
    }),
    {
      name: "sky-chat-disclaimer",
      partialize: (state) => ({ isDismissed: state.isDismissed }),
    }
  )
);
